import { MousePointerClick } from "lucide-react";
import { BUTTON_TEXTS } from "@/lib/buttonTexts";

// Caixa "Botões do site" do separador Textos. Os botões do topo (Hero) estão em Imagens & Branding.
export default function ButtonTextsEditor({ content, setContent }) {
  return (
    <div className="bg-[#1F1F1F] rounded-lg p-4 border border-[#3A3A3A]">
      <h3 className="text-[#A6C48A] font-bold mb-1 flex items-center gap-2">
        <MousePointerClick size={18} /> Botões do site
      </h3>
      <p className="text-[#8A8A8A] text-xs mb-4">
        Vazio = texto por omissão (a cinzento). Os dois botões do topo da página mudam-se em Imagens &amp; Branding.
      </p>
      <div className="grid md:grid-cols-2 gap-4">
        {BUTTON_TEXTS.map(({ key, label, fallback }) => (
          <div key={key}>
            <label className="block text-[#A1A1AA] text-xs mb-1">{label}</label>
            <input
              value={content[key] || ""}
              onChange={(e) => setContent((prev) => ({ ...prev, [key]: e.target.value }))}
              className="w-full bg-[#141414] border border-[#3A3A3A] rounded px-3 py-2 text-[#F5F5F5] text-sm"
              placeholder={fallback}
              maxLength={40}
            />
          </div>
        ))}
      </div>
    </div>
  );
}
